module.exports = __webpack_public_path__ + "assets/img/achived.36246d9c.png";